import 'core-js/modules/es.array.filter.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.promise.js';
import 'core-js/modules/es.object.assign.js';
import 'core-js/modules/es.regexp.to-string.js';
import Toastify from 'toastify-js';
import 'core-js/modules/es.array.map.js';
import { getGettextBuilder } from '@nextcloud/l10n/gettext';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

/// <reference types="@nextcloud/typings" />
var FilePickerType;
(function (FilePickerType) {
  FilePickerType[FilePickerType["Choose"] = 1] = "Choose";
  FilePickerType[FilePickerType["Move"] = 2] = "Move";
  FilePickerType[FilePickerType["Copy"] = 3] = "Copy";
  FilePickerType[FilePickerType["CopyMove"] = 4] = "CopyMove";
})(FilePickerType || (FilePickerType = {}));
var FilePicker = /*#__PURE__*/function () {
  function FilePicker(title, multiSelect, mimeTypeFilter, modal, type, directoriesAllowed, path, filter) {
    _classCallCheck(this, FilePicker);
    this.title = title;
    this.multiSelect = multiSelect;
    this.mimeTypeFiler = mimeTypeFilter;
    this.modal = modal;
    this.type = type;
    this.directoriesAllowed = directoriesAllowed;
    this.path = path;
    this.filter = filter;
  }
  _createClass(FilePicker, [{
    key: "pick",
    value: function pick() {
      var _this = this;
      return new Promise(function (res, rej) {
        OC.dialogs.filepicker(_this.title, res, _this.multiSelect, _this.mimeTypeFiler, _this.modal, _this.type, _this.path, {
          allowDirectoryChooser: _this.directoriesAllowed,
          filter: _this.filter
        });
      });
    }
  }]);
  return FilePicker;
}();
var FilePickerBuilder = /*#__PURE__*/function () {
  function FilePickerBuilder(title) {
    _classCallCheck(this, FilePickerBuilder);
    this.multiSelect = false;
    this.mimeTypeFiler = [];
    this.modal = true;
    this.type = FilePickerType.Choose;
    this.directoriesAllowed = false;
    this.title = title;
  }
  _createClass(FilePickerBuilder, [{
    key: "setMultiSelect",
    value: function setMultiSelect(ms) {
      this.multiSelect = ms;
      return this;
    }
  }, {
    key: "addMimeTypeFilter",
    value: function addMimeTypeFilter(filter) {
      this.mimeTypeFiler.push(filter);
      return this;
    }
  }, {
    key: "setMimeTypeFilter",
    value: function setMimeTypeFilter(filter) {
      this.mimeTypeFiler = filter;
      return this;
    }
  }, {
    key: "setModal",
    value: function setModal(modal) {
      this.modal = modal;
      return this;
    }
  }, {
    key: "setType",
    value: function setType(type) {
      this.type = type;
      return this;
    }
  }, {
    key: "allowDirectories",
    value: function allowDirectories() {
      var allow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.directoriesAllowed = allow;
      return this;
    }
  }, {
    key: "startAt",
    value: function startAt(path) {
      this.path = path;
      return this;
    }
  }, {
    key: "setFilter",
    value: function setFilter(filter) {
      this.filter = filter;
      return this;
    }
  }, {
    key: "build",
    value: function build() {
      return new FilePicker(this.title, this.multiSelect, this.mimeTypeFiler, this.modal, this.type, this.directoriesAllowed, this.path, this.filter);
    }
  }]);
  return FilePickerBuilder;
}();
function getFilePickerBuilder(title) {
  return new FilePickerBuilder(title);
}

var gtBuilder = getGettextBuilder().detectLocale();
[{
  "locale": "ar",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "S1 SYSTEMS | BP <info@s1.sa>, 2020",
      "Language-Team": "Arabic (https://www.transifex.com/nextcloud/teams/64236/ar/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "ar",
      "Plural-Forms": "nplurals=6; plural=n==0 ? 0 : n==1 ? 1 : n==2 ? 2 : n%100>=3 && n%100<=10 ? 3 : n%100>=11 && n%100<=99 ? 4 : 5;"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nS1 SYSTEMS | BP <info@s1.sa>, 2020\n"
          },
          "msgstr": ["Last-Translator: S1 SYSTEMS | BP <info@s1.sa>, 2020\nLanguage-Team: Arabic (https://www.transifex.com/nextcloud/teams/64236/ar/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: ar\nPlural-Forms: nplurals=6; plural=n==0 ? 0 : n==1 ? 1 : n==2 ? 2 : n%100>=3 && n%100<=10 ? 3 : n%100>=11 && n%100<=99 ? 4 : 5;\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:191"
          },
          "msgstr": ["تراجع"]
        }
      }
    }
  }
}, {
  "locale": "ast",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "enolp <enolp@softastur.org>, 2020",
      "Language-Team": "Asturian (https://www.transifex.com/nextcloud/teams/64236/ast/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "ast",
      "Plural-Forms": "nplurals=2; plural=(n != 1);"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nenolp <enolp@softastur.org>, 2020\n"
          },
          "msgstr": ["Last-Translator: enolp <enolp@softastur.org>, 2020\nLanguage-Team: Asturian (https://www.transifex.com/nextcloud/teams/64236/ast/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: ast\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:187"
          },
          "msgstr": ["Desfacer"]
        }
      }
    }
  }
}, {
  "locale": "br",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Kervoas-Le Nabat Ewen <ewenkervoas@free.fr>, 2020",
      "Language-Team": "Breton (https://www.transifex.com/nextcloud/teams/64236/br/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "br",
      "Plural-Forms": "nplurals=5; plural=((n%10 == 1) && (n%100 != 11) && (n%100 !=71) && (n%100 !=91) ? 0 :(n%10 == 2) && (n%100 != 12) && (n%100 !=72) && (n%100 !=92) ? 1 :(n%10 ==3 || n%10==4 || n%10==9) && (n%100 < 10 || n% 100 > 19) && (n%100 < 70 || n%100 > 79) && (n%100 < 90 || n%100 > 99) ? 2 :(n != 0 && n % 1000000 == 0) ? 3 : 4);"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nKervoas-Le Nabat Ewen <ewenkervoas@free.fr>, 2020\n"
          },
          "msgstr": ["Last-Translator: Kervoas-Le Nabat Ewen <ewenkervoas@free.fr>, 2020\nLanguage-Team: Breton (https://www.transifex.com/nextcloud/teams/64236/br/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: br\nPlural-Forms: nplurals=5; plural=((n%10 == 1) && (n%100 != 11) && (n%100 !=71) && (n%100 !=91) ? 0 :(n%10 == 2) && (n%100 != 12) && (n%100 !=72) && (n%100 !=92) ? 1 :(n%10 ==3 || n%10==4 || n%10==9) && (n%100 < 10 || n% 100 > 19) && (n%100 < 70 || n%100 > 79) && (n%100 < 90 || n%100 > 99) ? 2 :(n != 0 && n % 1000000 == 0) ? 3 : 4);\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:187"
          },
          "msgstr": ["Disober"]
        }
      }
    }
  }
}, {
  "locale": "ca",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Marc Riera <marcriera@softcatala.org>, 2020",
      "Language-Team": "Catalan (https://www.transifex.com/nextcloud/teams/64236/ca/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "ca",
      "Plural-Forms": "nplurals=2; plural=(n != 1);"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nMarc Riera <marcriera@softcatala.org>, 2020\n"
          },
          "msgstr": ["Last-Translator: Marc Riera <marcriera@softcatala.org>, 2020\nLanguage-Team: Catalan (https://www.transifex.com/nextcloud/teams/64236/ca/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: ca\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:187"
          },
          "msgstr": ["Desfés"]
        }
      }
    }
  }
}, {
  "locale": "cs",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Pavel Borecki <pavel.borecki@gmail.com>, 2020",
      "Language-Team": "Czech (https://www.transifex.com/nextcloud/teams/64236/cs/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "cs",
      "Plural-Forms": "nplurals=4; plural=(n == 1 && n % 1 == 0) ? 0 : (n >= 2 && n <= 4 && n % 1 == 0) ? 1: (n % 1 != 0 ) ? 2 : 3;"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nPavel Borecki <pavel.borecki@gmail.com>, 2020\n"
          },
          "msgstr": ["Last-Translator: Pavel Borecki <pavel.borecki@gmail.com>, 2020\nLanguage-Team: Czech (https://www.transifex.com/nextcloud/teams/64236/cs/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: cs\nPlural-Forms: nplurals=4; plural=(n == 1 && n % 1 == 0) ? 0 : (n >= 2 && n <= 4 && n % 1 == 0) ? 1: (n % 1 != 0 ) ? 2 : 3;\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:187"
          },
          "msgstr": ["Zpět"]
        }
      }
    }
  }
}, {
  "locale": "cs_CZ",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Pavel Borecki <pavel.borecki@gmail.com>, 2020",
      "Language-Team": "Czech (Czech Republic) (https://www.transifex.com/nextcloud/teams/64236/cs_CZ/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "cs_CZ",
      "Plural-Forms": "nplurals=4; plural=(n == 1 && n % 1 == 0) ? 0 : (n >= 2 && n <= 4 && n % 1 == 0) ? 1: (n % 1 != 0 ) ? 2 : 3;"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nPavel Borecki <pavel.borecki@gmail.com>, 2020\n"
          },
          "msgstr": ["Last-Translator: Pavel Borecki <pavel.borecki@gmail.com>, 2020\nLanguage-Team: Czech (Czech Republic) (https://www.transifex.com/nextcloud/teams/64236/cs_CZ/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: cs_CZ\nPlural-Forms: nplurals=4; plural=(n == 1 && n % 1 == 0) ? 0 : (n >= 2 && n <= 4 && n % 1 == 0) ? 1: (n % 1 != 0 ) ? 2 : 3;\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:187"
          },
          "msgstr": ["Zpět"]
        }
      }
    }
  }
}, {
  "locale": "da",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Martin Bonde <Martin@maboni.dk>, 2020",
      "Language-Team": "Danish (https://www.transifex.com/nextcloud/teams/64236/da/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "da",
      "Plural-Forms": "nplurals=2; plural=(n != 1);"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nMartin Bonde <Martin@maboni.dk>, 2020\n"
          },
          "msgstr": ["Last-Translator: Martin Bonde <Martin@maboni.dk>, 2020\nLanguage-Team: Danish (https://www.transifex.com/nextcloud/teams/64236/da/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: da\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:192"
          },
          "msgstr": ["Fortryd"]
        }
      }
    }
  }
}, {
  "locale": "de",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Mark Ziegler <mark.ziegler@rakekniven.de>, 2020",
      "Language-Team": "German (https://www.transifex.com/nextcloud/teams/64236/de/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "de",
      "Plural-Forms": "nplurals=2; plural=(n != 1);"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nMark Ziegler <mark.ziegler@rakekniven.de>, 2020\n"
          },
          "msgstr": ["Last-Translator: Mark Ziegler <mark.ziegler@rakekniven.de>, 2020\nLanguage-Team: German (https://www.transifex.com/nextcloud/teams/64236/de/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: de\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:187"
          },
          "msgstr": ["Rückgängig"]
        }
      }
    }
  }
}, {
  "locale": "de_DE",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Gustav Gyges, 2021",
      "Language-Team": "German (Germany) (https://www.transifex.com/nextcloud/teams/64236/de_DE/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "de_DE",
      "Plural-Forms": "nplurals=2; plural=(n != 1);"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nGustav Gyges, 2021\n"
          },
          "msgstr": ["Last-Translator: Gustav Gyges, 2021\nLanguage-Team: German (Germany) (https://www.transifex.com/nextcloud/teams/64236/de_DE/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: de_DE\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:192"
          },
          "msgstr": ["Rückgängig machen"]
        }
      }
    }
  }
}, {
  "locale": "el",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "ByteGet, 2020",
      "Language-Team": "Greek (https://www.transifex.com/nextcloud/teams/64236/el/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "el",
      "Plural-Forms": "nplurals=2; plural=(n != 1);"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nByteGet, 2020\n"
          },
          "msgstr": ["Last-Translator: ByteGet, 2020\nLanguage-Team: Greek (https://www.transifex.com/nextcloud/teams/64236/el/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: el\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:187"
          },
          "msgstr": ["Αναίρεση"]
        }
      }
    }
  }
}, {
  "locale": "en_GB",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Jeff Gunn <planemastr1@gmail.com>, 2021",
      "Language-Team": "English (United Kingdom) (https://www.transifex.com/nextcloud/teams/64236/en_GB/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "en_GB",
      "Plural-Forms": "nplurals=2; plural=(n != 1);"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nJeff Gunn <planemastr1@gmail.com>, 2021\n"
          },
          "msgstr": ["Last-Translator: Jeff Gunn <planemastr1@gmail.com>, 2021\nLanguage-Team: English (United Kingdom) (https://www.transifex.com/nextcloud/teams/64236/en_GB/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: en_GB\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:192"
          },
          "msgstr": ["Undo"]
        }
      }
    }
  }
}, {
  "locale": "eo",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Va Milushnikov <va.milushnikov@gmail.com>, 2020",
      "Language-Team": "Esperanto (https://www.transifex.com/nextcloud/teams/64236/eo/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "eo",
      "Plural-Forms": "nplurals=2; plural=(n != 1);"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nVa Milushnikov <va.milushnikov@gmail.com>, 2020\n"
          },
          "msgstr": ["Last-Translator: Va Milushnikov <va.milushnikov@gmail.com>, 2020\nLanguage-Team: Esperanto (https://www.transifex.com/nextcloud/teams/64236/eo/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: eo\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:191"
          },
          "msgstr": ["Malfari"]
        }
      }
    }
  }
}, {
  "locale": "es",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Gabriel Anca <gabrielancacorral@gmail.com>, 2020",
      "Language-Team": "Spanish (https://www.transifex.com/nextcloud/teams/64236/es/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "es",
      "Plural-Forms": "nplurals=2; plural=(n != 1);"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nGabriel Anca <gabrielancacorral@gmail.com>, 2020\n"
          },
          "msgstr": ["Last-Translator: Gabriel Anca <gabrielancacorral@gmail.com>, 2020\nLanguage-Team: Spanish (https://www.transifex.com/nextcloud/teams/64236/es/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: es\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:192"
          },
          "msgstr": ["Deshacer"]
        }
      }
    }
  }
}, {
  "locale": "es_AR",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Matias Iglesias, 2022",
      "Language-Team": "Spanish (Argentina) (https://www.transifex.com/nextcloud/teams/64236/es_AR/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "es_AR",
      "Plural-Forms": "nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nMatias Iglesias, 2022\n"
          },
          "msgstr": ["Last-Translator: Matias Iglesias, 2022\nLanguage-Team: Spanish (Argentina) (https://www.transifex.com/nextcloud/teams/64236/es_AR/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: es_AR\nPlural-Forms: nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:223"
          },
          "msgstr": ["Deshacer"]
        }
      }
    }
  }
}, {
  "locale": "es_MX",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Luis Francisco Castro, 2022",
      "Language-Team": "Spanish (Mexico) (https://www.transifex.com/nextcloud/teams/64236/es_MX/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "es_MX",
      "Plural-Forms": "nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nLuis Francisco Castro, 2022\n"
          },
          "msgstr": ["Last-Translator: Luis Francisco Castro, 2022\nLanguage-Team: Spanish (Mexico) (https://www.transifex.com/nextcloud/teams/64236/es_MX/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: es_MX\nPlural-Forms: nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:223"
          },
          "msgstr": ["Deshacer"]
        }
      }
    }
  }
}, {
  "locale": "eu",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Unai Tolosa Pontesta <utolosa002@gmail.com>, 2021",
      "Language-Team": "Basque (https://www.transifex.com/nextcloud/teams/64236/eu/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "eu",
      "Plural-Forms": "nplurals=2; plural=(n != 1);"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nUnai Tolosa Pontesta <utolosa002@gmail.com>, 2021\n"
          },
          "msgstr": ["Last-Translator: Unai Tolosa Pontesta <utolosa002@gmail.com>, 2021\nLanguage-Team: Basque (https://www.transifex.com/nextcloud/teams/64236/eu/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: eu\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:192"
          },
          "msgstr": ["Desegin"]
        }
      }
    }
  }
}, {
  "locale": "fa",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Mostafa Ahangarha <ahangarha@riseup.net>, 2020",
      "Language-Team": "Persian (https://www.transifex.com/nextcloud/teams/64236/fa/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "fa",
      "Plural-Forms": "nplurals=2; plural=(n > 1);"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nMostafa Ahangarha <ahangarha@riseup.net>, 2020\n"
          },
          "msgstr": ["Last-Translator: Mostafa Ahangarha <ahangarha@riseup.net>, 2020\nLanguage-Team: Persian (https://www.transifex.com/nextcloud/teams/64236/fa/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: fa\nPlural-Forms: nplurals=2; plural=(n > 1);\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:192"
          },
          "msgstr": ["بازگردانی"]
        }
      }
    }
  }
}, {
  "locale": "fi_FI",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "teemue, 2020",
      "Language-Team": "Finnish (Finland) (https://www.transifex.com/nextcloud/teams/64236/fi_FI/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "fi_FI",
      "Plural-Forms": "nplurals=2; plural=(n != 1);"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nteemue, 2020\n"
          },
          "msgstr": ["Last-Translator: teemue, 2020\nLanguage-Team: Finnish (Finland) (https://www.transifex.com/nextcloud/teams/64236/fi_FI/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: fi_FI\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:191"
          },
          "msgstr": ["Kumoa"]
        }
      }
    }
  }
}, {
  "locale": "fr",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "John Molakvoæ <skjnldsv@protonmail.com>, 2020",
      "Language-Team": "French (https://www.transifex.com/nextcloud/teams/64236/fr/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "fr",
      "Plural-Forms": "nplurals=2; plural=(n > 1);"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nJohn Molakvoæ <skjnldsv@protonmail.com>, 2020\n"
          },
          "msgstr": ["Last-Translator: John Molakvoæ <skjnldsv@protonmail.com>, 2020\nLanguage-Team: French (https://www.transifex.com/nextcloud/teams/64236/fr/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: fr\nPlural-Forms: nplurals=2; plural=(n > 1);\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:187"
          },
          "msgstr": ["Annuler"]
        }
      }
    }
  }
}, {
  "locale": "gl",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Miguel Anxo Bouzada <mbouzada@gmail.com>, 2020",
      "Language-Team": "Galician (https://www.transifex.com/nextcloud/teams/64236/gl/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "gl",
      "Plural-Forms": "nplurals=2; plural=(n != 1);"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nMiguel Anxo Bouzada <mbouzada@gmail.com>, 2020\n"
          },
          "msgstr": ["Last-Translator: Miguel Anxo Bouzada <mbouzada@gmail.com>, 2020\nLanguage-Team: Galician (https://www.transifex.com/nextcloud/teams/64236/gl/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: gl\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:187"
          },
          "msgstr": ["Desfacer"]
        }
      }
    }
  }
}, {
  "locale": "he",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Yaron Shahrabani <sh.yaron@gmail.com>, 2020",
      "Language-Team": "Hebrew (https://www.transifex.com/nextcloud/teams/64236/he/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "he",
      "Plural-Forms": "nplurals=4; plural=(n == 1 && n % 1 == 0) ? 0 : (n == 2 && n % 1 == 0) ? 1: (n % 10 == 0 && n % 1 == 0 && n > 10) ? 2 : 3;"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nYaron Shahrabani <sh.yaron@gmail.com>, 2020\n"
          },
          "msgstr": ["Last-Translator: Yaron Shahrabani <sh.yaron@gmail.com>, 2020\nLanguage-Team: Hebrew (https://www.transifex.com/nextcloud/teams/64236/he/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: he\nPlural-Forms: nplurals=4; plural=(n == 1 && n % 1 == 0) ? 0 : (n == 2 && n % 1 == 0) ? 1: (n % 10 == 0 && n % 1 == 0 && n > 10) ? 2 : 3;\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:187"
          },
          "msgstr": ["ביטול"]
        }
      }
    }
  }
}, {
  "locale": "hu_HU",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Balázs Meskó <meskobalazs@mailbox.org>, 2021",
      "Language-Team": "Hungarian (Hungary) (https://www.transifex.com/nextcloud/teams/64236/hu_HU/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "hu_HU",
      "Plural-Forms": "nplurals=2; plural=(n != 1);"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nBalázs Meskó <meskobalazs@mailbox.org>, 2021\n"
          },
          "msgstr": ["Last-Translator: Balázs Meskó <meskobalazs@mailbox.org>, 2021\nLanguage-Team: Hungarian (Hungary) (https://www.transifex.com/nextcloud/teams/64236/hu_HU/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: hu_HU\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:191"
          },
          "msgstr": ["Visszavonás"]
        }
      }
    }
  }
}, {
  "locale": "id",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "agus sutrisno <agussutrisno@smamsa.sch.id>, 2020",
      "Language-Team": "Indonesian (https://www.transifex.com/nextcloud/teams/64236/id/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "id",
      "Plural-Forms": "nplurals=1; plural=0;"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nagus sutrisno <agussutrisno@smamsa.sch.id>, 2020\n"
          },
          "msgstr": ["Last-Translator: agus sutrisno <agussutrisno@smamsa.sch.id>, 2020\nLanguage-Team: Indonesian (https://www.transifex.com/nextcloud/teams/64236/id/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: id\nPlural-Forms: nplurals=1; plural=0;\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:192"
          },
          "msgstr": ["Tidak jadi"]
        }
      }
    }
  }
}, {
  "locale": "is",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Sveinn í Felli <sv1@fellsnet.is>, 2020",
      "Language-Team": "Icelandic (https://www.transifex.com/nextcloud/teams/64236/is/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "is",
      "Plural-Forms": "nplurals=2; plural=(n % 10 != 1 || n % 100 == 11);"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nSveinn í Felli <sv1@fellsnet.is>, 2020\n"
          },
          "msgstr": ["Last-Translator: Sveinn í Felli <sv1@fellsnet.is>, 2020\nLanguage-Team: Icelandic (https://www.transifex.com/nextcloud/teams/64236/is/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: is\nPlural-Forms: nplurals=2; plural=(n % 10 != 1 || n % 100 == 11);\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:192"
          },
          "msgstr": ["Afturkalla"]
        }
      }
    }
  }
}, {
  "locale": "it",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Vincenzo Reale <vinx.reale@gmail.com>, 2020",
      "Language-Team": "Italian (https://www.transifex.com/nextcloud/teams/64236/it/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "it",
      "Plural-Forms": "nplurals=2; plural=(n != 1);"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nVincenzo Reale <vinx.reale@gmail.com>, 2020\n"
          },
          "msgstr": ["Last-Translator: Vincenzo Reale <vinx.reale@gmail.com>, 2020\nLanguage-Team: Italian (https://www.transifex.com/nextcloud/teams/64236/it/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: it\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:187"
          },
          "msgstr": ["Annulla"]
        }
      }
    }
  }
}, {
  "locale": "ja_JP",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "323484, 2020",
      "Language-Team": "Japanese (Japan) (https://www.transifex.com/nextcloud/teams/64236/ja_JP/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "ja_JP",
      "Plural-Forms": "nplurals=1; plural=0;"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\n323484, 2020\n"
          },
          "msgstr": ["Last-Translator: 323484, 2020\nLanguage-Team: Japanese (Japan) (https://www.transifex.com/nextcloud/teams/64236/ja_JP/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: ja_JP\nPlural-Forms: nplurals=1; plural=0;\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:187"
          },
          "msgstr": ["元に戻す"]
        }
      }
    }
  }
}, {
  "locale": "kab",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "ZiriSut, 2021",
      "Language-Team": "Kabyle (https://www.transifex.com/nextcloud/teams/64236/kab/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "kab",
      "Plural-Forms": "nplurals=2; plural=(n != 1);"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nZiriSut, 2021\n"
          },
          "msgstr": ["Last-Translator: ZiriSut, 2021\nLanguage-Team: Kabyle (https://www.transifex.com/nextcloud/teams/64236/kab/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: kab\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:192"
          },
          "msgstr": ["Sefsex"]
        }
      }
    }
  }
}, {
  "locale": "ko",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Brandon Han, 2021",
      "Language-Team": "Korean (https://www.transifex.com/nextcloud/teams/64236/ko/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "ko",
      "Plural-Forms": "nplurals=1; plural=0;"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nBrandon Han, 2021\n"
          },
          "msgstr": ["Last-Translator: Brandon Han, 2021\nLanguage-Team: Korean (https://www.transifex.com/nextcloud/teams/64236/ko/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: ko\nPlural-Forms: nplurals=1; plural=0;\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:192"
          },
          "msgstr": ["되돌리기"]
        }
      }
    }
  }
}, {
  "locale": "lt_LT",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Moo, 2020",
      "Language-Team": "Lithuanian (Lithuania) (https://www.transifex.com/nextcloud/teams/64236/lt_LT/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "lt_LT",
      "Plural-Forms": "nplurals=4; plural=(n % 10 == 1 && (n % 100 > 19 || n % 100 < 11) ? 0 : (n % 10 >= 2 && n % 10 <=9) && (n % 100 > 19 || n % 100 < 11) ? 1 : n % 1 != 0 ? 2: 3);"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nMoo, 2020\n"
          },
          "msgstr": ["Last-Translator: Moo, 2020\nLanguage-Team: Lithuanian (Lithuania) (https://www.transifex.com/nextcloud/teams/64236/lt_LT/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: lt_LT\nPlural-Forms: nplurals=4; plural=(n % 10 == 1 && (n % 100 > 19 || n % 100 < 11) ? 0 : (n % 10 >= 2 && n % 10 <=9) && (n % 100 > 19 || n % 100 < 11) ? 1 : n % 1 != 0 ? 2: 3);\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:187"
          },
          "msgstr": ["Atšaukti"]
        }
      }
    }
  }
}, {
  "locale": "mk",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Сашко Тодоров, 2020",
      "Language-Team": "Macedonian (https://www.transifex.com/nextcloud/teams/64236/mk/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "mk",
      "Plural-Forms": "nplurals=2; plural=(n % 10 == 1 && n % 100 != 11) ? 0 : 1;"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nСашко Тодоров, 2020\n"
          },
          "msgstr": ["Last-Translator: Сашко Тодоров, 2020\nLanguage-Team: Macedonian (https://www.transifex.com/nextcloud/teams/64236/mk/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: mk\nPlural-Forms: nplurals=2; plural=(n % 10 == 1 && n % 100 != 11) ? 0 : 1;\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:187"
          },
          "msgstr": ["Врати"]
        }
      }
    }
  }
}, {
  "locale": "mn",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "BATKHUYAG Ganbold <gbatkhuyag@gmail.com>, 2022",
      "Language-Team": "Mongolian (https://www.transifex.com/nextcloud/teams/64236/mn/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "mn",
      "Plural-Forms": "nplurals=2; plural=(n != 1);"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nBATKHUYAG Ganbold <gbatkhuyag@gmail.com>, 2022\n"
          },
          "msgstr": ["Last-Translator: BATKHUYAG Ganbold <gbatkhuyag@gmail.com>, 2022\nLanguage-Team: Mongolian (https://www.transifex.com/nextcloud/teams/64236/mn/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: mn\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:192"
          },
          "msgstr": ["Буцаах"]
        }
      }
    }
  }
}, {
  "locale": "mr",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Vinit Dhabre <VINIT@ymail.com>, 2021",
      "Language-Team": "Marathi (https://www.transifex.com/nextcloud/teams/64236/mr/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "mr",
      "Plural-Forms": "nplurals=2; plural=(n != 1);"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nVinit Dhabre <VINIT@ymail.com>, 2021\n"
          },
          "msgstr": ["Last-Translator: Vinit Dhabre <VINIT@ymail.com>, 2021\nLanguage-Team: Marathi (https://www.transifex.com/nextcloud/teams/64236/mr/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: mr\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:192"
          },
          "msgstr": ["पूर्ववत करा"]
        }
      }
    }
  }
}, {
  "locale": "my",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Htike Aung Kyaw <htikeagkyaw@gmail.com>, 2021",
      "Language-Team": "Burmese (https://www.transifex.com/nextcloud/teams/64236/my/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "my",
      "Plural-Forms": "nplurals=1; plural=0;"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nHtike Aung Kyaw <htikeagkyaw@gmail.com>, 2021\n"
          },
          "msgstr": ["Last-Translator: Htike Aung Kyaw <htikeagkyaw@gmail.com>, 2021\nLanguage-Team: Burmese (https://www.transifex.com/nextcloud/teams/64236/my/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: my\nPlural-Forms: nplurals=1; plural=0;\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:192"
          },
          "msgstr": ["နဂိုအတိုင်းပြန်ထားရန်"]
        }
      }
    }
  }
}, {
  "locale": "nb_NO",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "sverre.vikan <sverre.vikan@gmail.com>, 2020",
      "Language-Team": "Norwegian Bokmål (Norway) (https://www.transifex.com/nextcloud/teams/64236/nb_NO/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "nb_NO",
      "Plural-Forms": "nplurals=2; plural=(n != 1);"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nsverre.vikan <sverre.vikan@gmail.com>, 2020\n"
          },
          "msgstr": ["Last-Translator: sverre.vikan <sverre.vikan@gmail.com>, 2020\nLanguage-Team: Norwegian Bokmål (Norway) (https://www.transifex.com/nextcloud/teams/64236/nb_NO/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: nb_NO\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:192"
          },
          "msgstr": ["Angre"]
        }
      }
    }
  }
}, {
  "locale": "nl",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Robin Slot, 2020",
      "Language-Team": "Dutch (https://www.transifex.com/nextcloud/teams/64236/nl/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "nl",
      "Plural-Forms": "nplurals=2; plural=(n != 1);"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nRobin Slot, 2020\n"
          },
          "msgstr": ["Last-Translator: Robin Slot, 2020\nLanguage-Team: Dutch (https://www.transifex.com/nextcloud/teams/64236/nl/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: nl\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:191"
          },
          "msgstr": ["Ongedaan maken"]
        }
      }
    }
  }
}, {
  "locale": "oc",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Quentin PAGÈS, 2020",
      "Language-Team": "Occitan (post 1500) (https://www.transifex.com/nextcloud/teams/64236/oc/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "oc",
      "Plural-Forms": "nplurals=2; plural=(n > 1);"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nQuentin PAGÈS, 2020\n"
          },
          "msgstr": ["Last-Translator: Quentin PAGÈS, 2020\nLanguage-Team: Occitan (post 1500) (https://www.transifex.com/nextcloud/teams/64236/oc/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: oc\nPlural-Forms: nplurals=2; plural=(n > 1);\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:187"
          },
          "msgstr": ["Anullar"]
        }
      }
    }
  }
}, {
  "locale": "pl",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Robert Szmurło <robert.szmurlo@ee.pw.edu.pl>, 2020",
      "Language-Team": "Polish (https://www.transifex.com/nextcloud/teams/64236/pl/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "pl",
      "Plural-Forms": "nplurals=4; plural=(n==1 ? 0 : (n%10>=2 && n%10<=4) && (n%100<12 || n%100>14) ? 1 : n!=1 && (n%10>=0 && n%10<=1) || (n%10>=5 && n%10<=9) || (n%100>=12 && n%100<=14) ? 2 : 3);"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nRobert Szmurło <robert.szmurlo@ee.pw.edu.pl>, 2020\n"
          },
          "msgstr": ["Last-Translator: Robert Szmurło <robert.szmurlo@ee.pw.edu.pl>, 2020\nLanguage-Team: Polish (https://www.transifex.com/nextcloud/teams/64236/pl/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: pl\nPlural-Forms: nplurals=4; plural=(n==1 ? 0 : (n%10>=2 && n%10<=4) && (n%100<12 || n%100>14) ? 1 : n!=1 && (n%10>=0 && n%10<=1) || (n%10>=5 && n%10<=9) || (n%100>=12 && n%100<=14) ? 2 : 3);\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:187"
          },
          "msgstr": ["Cofnij"]
        }
      }
    }
  }
}, {
  "locale": "pt_BR",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Paulo Schopf, 2020",
      "Language-Team": "Portuguese (Brazil) (https://www.transifex.com/nextcloud/teams/64236/pt_BR/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "pt_BR",
      "Plural-Forms": "nplurals=2; plural=(n > 1);"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nPaulo Schopf, 2020\n"
          },
          "msgstr": ["Last-Translator: Paulo Schopf, 2020\nLanguage-Team: Portuguese (Brazil) (https://www.transifex.com/nextcloud/teams/64236/pt_BR/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: pt_BR\nPlural-Forms: nplurals=2; plural=(n > 1);\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:187"
          },
          "msgstr": ["Desfazer"]
        }
      }
    }
  }
}, {
  "locale": "pt_PT",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Manuela Silva <mmsrs@sky.com>, 2022",
      "Language-Team": "Portuguese (Portugal) (https://www.transifex.com/nextcloud/teams/64236/pt_PT/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "pt_PT",
      "Plural-Forms": "nplurals=3; plural=(n == 0 || n == 1) ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nManuela Silva <mmsrs@sky.com>, 2022\n"
          },
          "msgstr": ["Last-Translator: Manuela Silva <mmsrs@sky.com>, 2022\nLanguage-Team: Portuguese (Portugal) (https://www.transifex.com/nextcloud/teams/64236/pt_PT/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: pt_PT\nPlural-Forms: nplurals=3; plural=(n == 0 || n == 1) ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:223"
          },
          "msgstr": ["Anular"]
        }
      }
    }
  }
}, {
  "locale": "ro",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Mădălin Vasiliu <contact@madalinvasiliu.com>, 2022",
      "Language-Team": "Romanian (https://www.transifex.com/nextcloud/teams/64236/ro/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "ro",
      "Plural-Forms": "nplurals=3; plural=(n==1?0:(((n%100>19)||((n%100==0)&&(n!=0)))?2:1));"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nMădălin Vasiliu <contact@madalinvasiliu.com>, 2022\n"
          },
          "msgstr": ["Last-Translator: Mădălin Vasiliu <contact@madalinvasiliu.com>, 2022\nLanguage-Team: Romanian (https://www.transifex.com/nextcloud/teams/64236/ro/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: ro\nPlural-Forms: nplurals=3; plural=(n==1?0:(((n%100>19)||((n%100==0)&&(n!=0)))?2:1));\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:193"
          },
          "msgstr": ["Anulează"]
        }
      }
    }
  }
}, {
  "locale": "ru",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Andrey Atapin <atab@kirovedu.ru>, 2020",
      "Language-Team": "Russian (https://www.transifex.com/nextcloud/teams/64236/ru/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "ru",
      "Plural-Forms": "nplurals=4; plural=(n%10==1 && n%100!=11 ? 0 : n%10>=2 && n%10<=4 && (n%100<12 || n%100>14) ? 1 : n%10==0 || (n%10>=5 && n%10<=9) || (n%100>=11 && n%100<=14)? 2 : 3);"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nAndrey Atapin <atab@kirovedu.ru>, 2020\n"
          },
          "msgstr": ["Last-Translator: Andrey Atapin <atab@kirovedu.ru>, 2020\nLanguage-Team: Russian (https://www.transifex.com/nextcloud/teams/64236/ru/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: ru\nPlural-Forms: nplurals=4; plural=(n%10==1 && n%100!=11 ? 0 : n%10>=2 && n%10<=4 && (n%100<12 || n%100>14) ? 1 : n%10==0 || (n%10>=5 && n%10<=9) || (n%100>=11 && n%100<=14)? 2 : 3);\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:187"
          },
          "msgstr": ["Отменить"]
        }
      }
    }
  }
}, {
  "locale": "si",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Hela Basa, 2021",
      "Language-Team": "Sinhala (https://www.transifex.com/nextcloud/teams/64236/si/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "si",
      "Plural-Forms": "nplurals=2; plural=(n != 1);"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nHela Basa, 2021\n"
          },
          "msgstr": ["Last-Translator: Hela Basa, 2021\nLanguage-Team: Sinhala (https://www.transifex.com/nextcloud/teams/64236/si/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: si\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:192"
          },
          "msgstr": ["පෙරසේ"]
        }
      }
    }
  }
}, {
  "locale": "sk_SK",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "vladimirjendrol <vlado@jendrol.sk>, 2020",
      "Language-Team": "Slovak (Slovakia) (https://www.transifex.com/nextcloud/teams/64236/sk_SK/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "sk_SK",
      "Plural-Forms": "nplurals=4; plural=(n % 1 == 0 && n == 1 ? 0 : n % 1 == 0 && n >= 2 && n <= 4 ? 1 : n % 1 != 0 ? 2: 3);"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nvladimirjendrol <vlado@jendrol.sk>, 2020\n"
          },
          "msgstr": ["Last-Translator: vladimirjendrol <vlado@jendrol.sk>, 2020\nLanguage-Team: Slovak (Slovakia) (https://www.transifex.com/nextcloud/teams/64236/sk_SK/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: sk_SK\nPlural-Forms: nplurals=4; plural=(n % 1 == 0 && n == 1 ? 0 : n % 1 == 0 && n >= 2 && n <= 4 ? 1 : n % 1 != 0 ? 2: 3);\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:192"
          },
          "msgstr": ["Späť"]
        }
      }
    }
  }
}, {
  "locale": "sl",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Matej Urbančič <>, 2020",
      "Language-Team": "Slovenian (https://www.transifex.com/nextcloud/teams/64236/sl/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "sl",
      "Plural-Forms": "nplurals=4; plural=(n%100==1 ? 0 : n%100==2 ? 1 : n%100==3 || n%100==4 ? 2 : 3);"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nMatej Urbančič <>, 2020\n"
          },
          "msgstr": ["Last-Translator: Matej Urbančič <>, 2020\nLanguage-Team: Slovenian (https://www.transifex.com/nextcloud/teams/64236/sl/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: sl\nPlural-Forms: nplurals=4; plural=(n%100==1 ? 0 : n%100==2 ? 1 : n%100==3 || n%100==4 ? 2 : 3);\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:191"
          },
          "msgstr": ["Razveljavi"]
        }
      }
    }
  }
}, {
  "locale": "sr",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Иван Пешић, 2023",
      "Language-Team": "Serbian (https://www.transifex.com/nextcloud/teams/64236/sr/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "sr",
      "Plural-Forms": "nplurals=3; plural=(n%10==1 && n%100!=11 ? 0 : n%10>=2 && n%10<=4 && (n%100<10 || n%100>=20) ? 1 : 2);"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nИван Пешић, 2023\n"
          },
          "msgstr": ["Last-Translator: Иван Пешић, 2023\nLanguage-Team: Serbian (https://www.transifex.com/nextcloud/teams/64236/sr/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: sr\nPlural-Forms: nplurals=3; plural=(n%10==1 && n%100!=11 ? 0 : n%10>=2 && n%10<=4 && (n%100<10 || n%100>=20) ? 1 : 2);\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:223"
          },
          "msgstr": ["Поништи"]
        }
      }
    }
  }
}, {
  "locale": "sv",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Victor Nyberg <v70123@gmail.com>, 2021",
      "Language-Team": "Swedish (https://www.transifex.com/nextcloud/teams/64236/sv/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "sv",
      "Plural-Forms": "nplurals=2; plural=(n != 1);"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nVictor Nyberg <v70123@gmail.com>, 2021\n"
          },
          "msgstr": ["Last-Translator: Victor Nyberg <v70123@gmail.com>, 2021\nLanguage-Team: Swedish (https://www.transifex.com/nextcloud/teams/64236/sv/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: sv\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:191"
          },
          "msgstr": ["Ångra"]
        }
      }
    }
  }
}, {
  "locale": "ta",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "ஒளியன் Oliyan, 2022",
      "Language-Team": "Tamil (https://www.transifex.com/nextcloud/teams/64236/ta/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "ta",
      "Plural-Forms": "nplurals=2; plural=(n != 1);"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nஒளியன் Oliyan, 2022\n"
          },
          "msgstr": ["Last-Translator: ஒளியன் Oliyan, 2022\nLanguage-Team: Tamil (https://www.transifex.com/nextcloud/teams/64236/ta/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: ta\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:192"
          },
          "msgstr": ["செயல்தவிர்"]
        }
      }
    }
  }
}, {
  "locale": "th_TH",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Phongpanot Phairat <ppnplus@protonmail.com>, 2021",
      "Language-Team": "Thai (Thailand) (https://www.transifex.com/nextcloud/teams/64236/th_TH/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "th_TH",
      "Plural-Forms": "nplurals=1; plural=0;"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nPhongpanot Phairat <ppnplus@protonmail.com>, 2021\n"
          },
          "msgstr": ["Last-Translator: Phongpanot Phairat <ppnplus@protonmail.com>, 2021\nLanguage-Team: Thai (Thailand) (https://www.transifex.com/nextcloud/teams/64236/th_TH/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: th_TH\nPlural-Forms: nplurals=1; plural=0;\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:192"
          },
          "msgstr": ["เลิกทำ"]
        }
      }
    }
  }
}, {
  "locale": "tr",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Kaya Zeren <kayazeren@gmail.com>, 2020",
      "Language-Team": "Turkish (https://www.transifex.com/nextcloud/teams/64236/tr/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "tr",
      "Plural-Forms": "nplurals=2; plural=(n > 1);"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nKaya Zeren <kayazeren@gmail.com>, 2020\n"
          },
          "msgstr": ["Last-Translator: Kaya Zeren <kayazeren@gmail.com>, 2020\nLanguage-Team: Turkish (https://www.transifex.com/nextcloud/teams/64236/tr/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: tr\nPlural-Forms: nplurals=2; plural=(n > 1);\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:191"
          },
          "msgstr": ["Geri al"]
        }
      }
    }
  }
}, {
  "locale": "uk",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Oleksandr Panasyuk, 2021",
      "Language-Team": "Ukrainian (https://www.transifex.com/nextcloud/teams/64236/uk/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "uk",
      "Plural-Forms": "nplurals=4; plural=(n % 1 == 0 && n % 10 == 1 && n % 100 != 11 ? 0 : n % 1 == 0 && n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 12 || n % 100 > 14) ? 1 : n % 1 == 0 && (n % 10 ==0 || (n % 10 >=5 && n % 10 <=9) || (n % 100 >=11 && n % 100 <=14 )) ? 2: 3);"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nOleksandr Panasyuk, 2021\n"
          },
          "msgstr": ["Last-Translator: Oleksandr Panasyuk, 2021\nLanguage-Team: Ukrainian (https://www.transifex.com/nextcloud/teams/64236/uk/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: uk\nPlural-Forms: nplurals=4; plural=(n % 1 == 0 && n % 10 == 1 && n % 100 != 11 ? 0 : n % 1 == 0 && n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 12 || n % 100 > 14) ? 1 : n % 1 == 0 && (n % 10 ==0 || (n % 10 >=5 && n % 10 <=9) || (n % 100 >=11 && n % 100 <=14 )) ? 2: 3);\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:192"
          },
          "msgstr": ["Скасувати дію"]
        }
      }
    }
  }
}, {
  "locale": "vi",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Luu Thang <luuthang@vif.vn>, 2021",
      "Language-Team": "Vietnamese (https://www.transifex.com/nextcloud/teams/64236/vi/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "vi",
      "Plural-Forms": "nplurals=1; plural=0;"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nLuu Thang <luuthang@vif.vn>, 2021\n"
          },
          "msgstr": ["Last-Translator: Luu Thang <luuthang@vif.vn>, 2021\nLanguage-Team: Vietnamese (https://www.transifex.com/nextcloud/teams/64236/vi/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: vi\nPlural-Forms: nplurals=1; plural=0;\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:192"
          },
          "msgstr": ["Hoàn tác"]
        }
      }
    }
  }
}, {
  "locale": "zh_CN",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Henry Ji, 2022",
      "Language-Team": "Chinese (China) (https://www.transifex.com/nextcloud/teams/64236/zh_CN/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "zh_CN",
      "Plural-Forms": "nplurals=1; plural=0;"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nHenry Ji, 2022\n"
          },
          "msgstr": ["Last-Translator: Henry Ji, 2022\nLanguage-Team: Chinese (China) (https://www.transifex.com/nextcloud/teams/64236/zh_CN/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: zh_CN\nPlural-Forms: nplurals=1; plural=0;\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:192"
          },
          "msgstr": [" 撤消"]
        }
      }
    }
  }
}, {
  "locale": "zh_HK",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Cha Wong <cafetango@gmail.com>, 2021",
      "Language-Team": "Chinese (Hong Kong) (https://www.transifex.com/nextcloud/teams/64236/zh_HK/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "zh_HK",
      "Plural-Forms": "nplurals=1; plural=0;"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nCha Wong <cafetango@gmail.com>, 2021\n"
          },
          "msgstr": ["Last-Translator: Cha Wong <cafetango@gmail.com>, 2021\nLanguage-Team: Chinese (Hong Kong) (https://www.transifex.com/nextcloud/teams/64236/zh_HK/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: zh_HK\nPlural-Forms: nplurals=1; plural=0;\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:191"
          },
          "msgstr": ["還原"]
        }
      }
    }
  }
}, {
  "locale": "zh_TW",
  "json": {
    "charset": "utf-8",
    "headers": {
      "Last-Translator": "Natashia Maxins <railroad1987@gmail.com>, 2020",
      "Language-Team": "Chinese (Taiwan) (https://www.transifex.com/nextcloud/teams/64236/zh_TW/)",
      "Content-Type": "text/plain; charset=UTF-8",
      "Language": "zh_TW",
      "Plural-Forms": "nplurals=1; plural=0;"
    },
    "translations": {
      "": {
        "": {
          "msgid": "",
          "comments": {
            "translator": "\nTranslators:\nNatashia Maxins <railroad1987@gmail.com>, 2020\n"
          },
          "msgstr": ["Last-Translator: Natashia Maxins <railroad1987@gmail.com>, 2020\nLanguage-Team: Chinese (Taiwan) (https://www.transifex.com/nextcloud/teams/64236/zh_TW/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: zh_TW\nPlural-Forms: nplurals=1; plural=0;\n"]
        },
        "Undo": {
          "msgid": "Undo",
          "comments": {
            "reference": "lib/toast.ts:192"
          },
          "msgstr": ["復原"]
        }
      }
    }
  }
}].map(function (data) {
  return gtBuilder.addTranslation(data.locale, data.json);
});
var gt = gtBuilder.build();
gt.ngettext.bind(gt);
var t = gt.gettext.bind(gt);

var ToastType = /*#__PURE__*/_createClass(function ToastType() {
  _classCallCheck(this, ToastType);
});
ToastType.ERROR = 'toast-error';
ToastType.WARNING = 'toast-warning';
ToastType.INFO = 'toast-info';
ToastType.SUCCESS = 'toast-success';
ToastType.PERMANENT = 'toast-error';
ToastType.UNDO = 'toast-undo';
var TOAST_ARIA_LIVE_OFF = 'off';
var TOAST_ARIA_LIVE_POLITE = 'polite';
var TOAST_ARIA_LIVE_ASSERTIVE = 'assertive';
var ToastAriaLive = /*#__PURE__*/_createClass(function ToastAriaLive() {
  _classCallCheck(this, ToastAriaLive);
});
ToastAriaLive.OFF = TOAST_ARIA_LIVE_OFF;
ToastAriaLive.POLITE = TOAST_ARIA_LIVE_POLITE;
ToastAriaLive.ASSERTIVE = TOAST_ARIA_LIVE_ASSERTIVE;
var TOAST_UNDO_TIMEOUT = 10000;
var TOAST_DEFAULT_TIMEOUT = 7000;
var TOAST_PERMANENT_TIMEOUT = -1;
/**
 * Show a toast message
 *
 * @param text Message to be shown in the toast, any HTML is removed by default
 * @param options
 */
function showMessage(data, options) {
  var _Toastify;
  var _a;
  options = Object.assign({
    timeout: TOAST_DEFAULT_TIMEOUT,
    isHTML: false,
    type: undefined,
    // An undefined selector defaults to the body element
    selector: undefined,
    onRemove: function onRemove() {},
    onClick: undefined,
    close: true
  }, options);
  if (typeof data === 'string' && !options.isHTML) {
    // fime mae sure that text is extracted
    var element = document.createElement('div');
    element.innerHTML = data;
    data = element.innerText;
  }
  var classes = (_a = options.type) !== null && _a !== void 0 ? _a : '';
  if (typeof options.onClick === 'function') {
    classes += ' toast-with-click ';
  }
  var isNode = data instanceof Node;
  var ariaLive = ToastAriaLive.POLITE;
  if (options.ariaLive) {
    ariaLive = options.ariaLive.toString();
  } else if (options.type === ToastType.ERROR || options.type === ToastType.UNDO) {
    ariaLive = ToastAriaLive.ASSERTIVE;
  }
  var toast = Toastify((_Toastify = {}, _defineProperty(_Toastify, !isNode ? 'text' : 'node', data), _defineProperty(_Toastify, "duration", options.timeout), _defineProperty(_Toastify, "callback", options.onRemove), _defineProperty(_Toastify, "onClick", options.onClick), _defineProperty(_Toastify, "close", options.close), _defineProperty(_Toastify, "gravity", 'top'), _defineProperty(_Toastify, "selector", options.selector), _defineProperty(_Toastify, "position", 'right'), _defineProperty(_Toastify, "backgroundColor", ''), _defineProperty(_Toastify, "className", 'dialogs ' + classes), _defineProperty(_Toastify, "escapeMarkup", !options.isHTML), _defineProperty(_Toastify, "ariaLive", ariaLive), _Toastify));
  toast.showToast();
  return toast;
}
/**
 * Show a toast message with error styling
 *
 * @param text Message to be shown in the toast, any HTML is removed by default
 * @param options
 */
function showError(text, options) {
  return showMessage(text, Object.assign(Object.assign({}, options), {
    type: ToastType.ERROR
  }));
}
/**
 * Show a toast message with warning styling
 *
 * @param text Message to be shown in the toast, any HTML is removed by default
 * @param options
 */
function showWarning(text, options) {
  return showMessage(text, Object.assign(Object.assign({}, options), {
    type: ToastType.WARNING
  }));
}
/**
 * Show a toast message with info styling
 *
 * @param text Message to be shown in the toast, any HTML is removed by default
 * @param options
 */
function showInfo(text, options) {
  return showMessage(text, Object.assign(Object.assign({}, options), {
    type: ToastType.INFO
  }));
}
/**
 * Show a toast message with success styling
 *
 * @param text Message to be shown in the toast, any HTML is removed by default
 * @param options
 */
function showSuccess(text, options) {
  return showMessage(text, Object.assign(Object.assign({}, options), {
    type: ToastType.SUCCESS
  }));
}
/**
 * Show a toast message with undo styling
 *
 * @param text Message to be shown in the toast, any HTML is removed by default
 * @param onUndo Function that is called when the undo button is clicked
 * @param options
 */
function showUndo(text, onUndo, options) {
  // onUndo callback is mandatory
  if (!(onUndo instanceof Function)) {
    throw new Error('Please provide a valid onUndo method');
  }
  var toast;
  options = Object.assign(options || {}, {
    // force 10 seconds of timeout
    timeout: TOAST_UNDO_TIMEOUT,
    // remove close button
    close: false
  });
  // Generate undo layout
  var undoContent = document.createElement('span');
  var undoButton = document.createElement('button');
  undoContent.classList.add('toast-undo-container');
  undoButton.classList.add('toast-undo-button');
  undoButton.innerText = t('Undo');
  undoContent.innerText = text;
  undoContent.appendChild(undoButton);
  undoButton.addEventListener('click', function (event) {
    event.stopPropagation();
    onUndo(event);
    // Hide toast
    if ((toast === null || toast === void 0 ? void 0 : toast.hideToast) instanceof Function) {
      toast.hideToast();
    }
  });
  toast = showMessage(undoContent, Object.assign(Object.assign({}, options), {
    type: ToastType.UNDO
  }));
  return toast;
}

export { FilePicker, FilePickerBuilder, FilePickerType, TOAST_ARIA_LIVE_ASSERTIVE, TOAST_ARIA_LIVE_OFF, TOAST_ARIA_LIVE_POLITE, TOAST_DEFAULT_TIMEOUT, TOAST_PERMANENT_TIMEOUT, TOAST_UNDO_TIMEOUT, getFilePickerBuilder, showError, showInfo, showMessage, showSuccess, showUndo, showWarning };
//# sourceMappingURL=index.mjs.map
